import { render, staticRenderFns } from "./LabReportWorkflowForm.vue?vue&type=template&id=6e2620de&scoped=true&lang=html&"
import script from "./LabReportWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./LabReportWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2620de",
  null
  
)

export default component.exports